import { Component, Input, OnInit } from '@angular/core';
import { BadgeType } from '@shared/utils/evidence-management';

@Component({
  selector: 'shared-ui-page-toolbars-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  standalone: false,
})
export class HeaderComponent implements OnInit {
  @Input() text = '';
  @Input() badgeText?: string;
  @Input() badgeType?: BadgeType;

  constructor() {}

  ngOnInit(): void {}
}
